"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames6 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var visuallyHiddenStyles = _interopRequireWildcard(require("../../../style/display/visually-hidden.module.scss"));
var _escapeRegexSpecialChars = require("../../../utils/string/escapeRegexSpecialChars");
var styles = _interopRequireWildcard(require("./title.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getTitleWithoutBrand = function getTitleWithoutBrand() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var brand = arguments.length > 1 ? arguments[1] : undefined;
  var isAnyday = arguments.length > 2 ? arguments[2] : undefined;
  if (!brand || !title) {
    return title;
  }
  return isAnyday ? title.replace(new RegExp(/^anyday john lewis & partners|^john lewis anyday/, 'i'), '').trim() : title.replace(new RegExp("^".concat((0, _escapeRegexSpecialChars.escapeRegexSpecialChars)(brand)), 'i'), '').trim();
};
var Title = function Title(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    brand = _ref.brand,
    _ref$brandPrefix = _ref.brandPrefix,
    brandPrefix = _ref$brandPrefix === void 0 ? '' : _ref$brandPrefix,
    selectedSwatch = _ref.selectedSwatch,
    isBranded = _ref.isBranded,
    isAnyday = _ref.isAnyday,
    _ref$headerTagLevel = _ref.headerTagLevel,
    headerTagLevel = _ref$headerTagLevel === void 0 ? 2 : _ref$headerTagLevel,
    _ref$isUnlimitedLines = _ref.isUnlimitedLines,
    isUnlimitedLines = _ref$isUnlimitedLines === void 0 ? false : _ref$isUnlimitedLines;
  if (!title) {
    return '';
  }
  var isUnbrandedBrand = brand === 'Unbranded';
  var titleWithoutBrand = isUnbrandedBrand ? title : getTitleWithoutBrand(title, brand, isAnyday);
  var HeaderTag = "h".concat(headerTagLevel > 0 && headerTagLevel < 7 ? headerTagLevel : 2);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(HeaderTag, {
    className: styles.title,
    children: [isBranded && !isUnbrandedBrand || isAnyday || brand === 'CHANEL' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: (0, _classnames6.default)(styles.title__brand, _defineProperty({}, styles["title__brand--".concat(brand.toLowerCase())], brand)),
        children: [brandPrefix && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: styles.title__brandPrefix,
          children: brandPrefix
        }), "".concat(brand, " ")]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: (0, _classnames6.default)(styles.title__desc, _defineProperty({}, styles['title__desc--three-lines'], !isUnlimitedLines), _defineProperty({}, styles['title__desc--branded'], isBranded)),
        children: titleWithoutBrand
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: (0, _classnames6.default)(styles.title__desc, _defineProperty({}, styles['title__desc--four-lines'], !isUnlimitedLines), _defineProperty({}, styles['title__desc--branded'], isBranded && isUnbrandedBrand)),
      children: title
    }), (selectedSwatch === null || selectedSwatch === void 0 ? void 0 : selectedSwatch.color) && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: visuallyHiddenStyles.visuallyHidden,
      children: ", ".concat(selectedSwatch.color)
    })]
  });
};
Title.propTypes = {
  title: _propTypes.default.string,
  brand: _propTypes.default.string,
  brandPrefix: _propTypes.default.string,
  isBranded: _propTypes.default.bool,
  isAnyday: _propTypes.default.bool,
  headerTagLevel: _propTypes.default.number,
  isUnlimitedLines: _propTypes.default.bool
};
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(Title);